export default {
  TITLE: 'Mes messages',
  SUMMARY: 'Les messages permettent à votre compagnie de vous communiquer des informations importantes.',
  PUBLISHED_BY: 'Publié par {{ name }} le {{ date }}',
  POSTED: 'Publié',
  IMPORTANT: 'Important',
  NEW: 'Nouveau',
  NO_MESSAGES: 'Aucun message à afficher.',
  SHOWN_TO: `Affiché à`,
  SHOWN_TO_EVERONE: `Affiché à tous les utilisateurs.`,
  NO_CONTENT: `Aucun contenu dans l'annonce`,
  SHOW: `Montrer`,
  HIDE: `Cacher`,
  SHOW_HIDDEN_MESSAGES: `Montrer les messages cachés`,
  HIDE_HIDDEN_MESSAGES: `Cacher les messages cachés`
}
